import { AsyncPipe, NgIf } from '@angular/common';
import { Component, Input, Self } from '@angular/core';
import { CmsArea } from '@domgen/dgx-fe-cms';
import { GAPage } from '@domgen/dgx-fe-ga';
import { EditableArea } from '@magnolia/angular-editor';
import { ErrorComponentService } from '../../services/error/error-component.service';

@Component({
  templateUrl: './error.component.html',
  standalone: true,
  imports: [AsyncPipe, EditableArea, NgIf],
  providers: [ErrorComponentService],
})
@GAPage()
export class ErrorComponent {
  @Input() errorPageContentBlock!: CmsArea;
  @Input() main!: CmsArea;

  constructor(@Self() readonly cs: ErrorComponentService) {}
}
